export const RecordOnMeetingFragment = gql`
  fragment RecordOnMeetingFragment on RecordOnMeeting {
    id
    canBeRemoved
    cannotBeRemovedReason
    files {
      ...FileFragment
    }
    meeting {
      id
      uuid
      startTime
      location
      cancelledAt
      meetingBoard {
        id
        name
      }
    }
    meetingResult {
      id
      name
    }
  }
`
